import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { NavigationStacks, Screens, Stacks } from 'components/Navigation/types';
import { useSelector } from 'hooks/useSelector';
import * as React from 'react';
import { selectAseIsOnline } from 'store/assessments/selectors';

import { AseInstanceCheckEdit } from './PagesMain/AseInstanceCheckEdit';
import { AseInstanceCheckDisplay } from './PagesMain/AseInstanceCheckDisplay';

type Props = NativeStackScreenProps<
  NavigationStacks[Stacks.ASEREPEATABLE],
  Screens.AseInstanceCheck
>;

export const FieldInstanceCheckScreen: React.FC<Props> = ({
  navigation,
  route,
}) => {
  const { id, instanceId } = route.params;
  const isOnline = useSelector(selectAseIsOnline);
  if (!isOnline) {
    return (
      <AseInstanceCheckEdit
        route={{ params: { id, instanceId } }}
        navigation={navigation}
      />
    );
  }
  return (
    <AseInstanceCheckDisplay
      route={{ params: { id, instanceId } }}
      navigation={navigation}
    />
  );
};
